/* eslint-disable no-sparse-arrays */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Divider } from '@material-ui/core';

// import Searchs from './searchs';
import Row from './rows';
import CheckboxRedux from '../global/checkbox_list';
import GetApi from '../../api/Get';
import Lottie from '../../lottie';
import TablePaginationActions from './paginationsActions';
import FilterTable from './searchs';

const useStyles2 = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  tableSpacer: {
    flex: 'initial',
  },
  tableToolbar: {
    justifyContent: 'center'
  },
  jsonContent: {
    position: 'absolute',
    top: 36,
    right: 0,
    left: 0,
  },
  textField: {
    margin: theme.spacing(2, 1),
    width: 200,
  },
  gridContainer:{
    paddingLeft: theme.spacing(1),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  buttonExport:{
    backgroundColor: "#24864e",
    '&:hover': {
      backgroundColor: '#206f43'
    }
  },
  dateField:{
    marginTop: theme.spacing(2) - 3,
    paddingLeft: theme.spacing(1),
  },
  toolbar:{
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  divider:{
    margin: theme.spacing(1),
  }
}));

export default function CustomPaginationActionsTable(props) {
  // const { customer_ids } = props;
  // const [dataSearch, setDataSearch] = React.useState({customer_ids});
  const [dataSearch, setDataSearch] = React.useState({});
  
  const classes = useStyles2();
  const rowsPerPage = 10;
  
  React.useEffect(() => {

    if(dataSearch){
      getList();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [, dataSearch]);


  const [data, setData] = React.useState(null);
  const [page, setPage] = React.useState(1);
  const emptyRows = rowsPerPage - (data ? data.results.length : 10);

  function getList(newPage=1){
    setPage(newPage);
    setData(null);
    GetApi.listCustomers({...dataSearch, page: newPage})
    .then( response => {
      setData(response);
    }).catch(e => {
      console.log("e", e);
    });
  }
  
  function handleChangePage(event, newPage) {
    getList(newPage + 1);
  }

  const handleChangeDataSearch = data => {

    const params = {};
    // const params = new URLSearchParams();

    // eslint-disable-next-line array-callback-return
    Object.keys(data).map((key, index) =>{
      var value = data[key];
      
      if(Array.isArray(value)){
        value = value.length ? value.map(function(item) {
          return item.id || item.value;
        }) : null;
      }
      
      if(value){
        params[key] = value;
      }
    })
    
    window.location.hash = `?${new URLSearchParams(params).toString()}`;

    setDataSearch(params);
  }

  return (
    <Paper className={classes.root}>
      <FilterTable callback={handleChangeDataSearch}/>

      <Divider className={classes.divider}/>

      <div className={classes.tableWrapper} >
              
        <Table size="small" >
          <TableHead>
            <TableRow>
              <TableCell variant="body">
                <CheckboxRedux list_name="customer_list" all />
              </TableCell>
              <TableCell variant="body"><strong>Id</strong></TableCell>
              <TableCell variant="body"><strong>Marca</strong></TableCell>
              <TableCell variant="body"><strong>Tipo</strong></TableCell>
              <TableCell variant="body"><strong>Estado</strong></TableCell>
              <TableCell variant="body"><strong>Cotizador de Autos</strong></TableCell>
              <TableCell variant="body"><strong>Facturación Electronica</strong></TableCell>
              <TableCell variant="body"><strong>Página Web</strong></TableCell>
              <TableCell variant="body"><strong>Marca Blanca</strong></TableCell>
              <TableCell variant="body"><strong>Solicitudes</strong></TableCell>
              <TableCell variant="body"><strong>Activo</strong></TableCell>
              <TableCell variant="body"><strong>Observaciones</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>

            {data == null ? (
              <TableRow style={{ height: 61 * 10 }}>
                <TableCell colSpan={14} align='center'>
                  <Lottie size={10}/>
                  {/* Cargando... */}
                </TableCell>
              </TableRow>
            ) : data.results.map( (row, index) => (
              <Row key={index} row={row}/>
            ))}

            {emptyRows > 0 && (
              <TableRow style={{ height: 61 * emptyRows }}>
                <TableCell colSpan={7} />
              </TableRow>
            )}
            

          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                classes={{
                  toolbar: classes.tableToolbar,
                  spacer: classes.tableSpacer
                }}
                colSpan={14}
                rowsPerPageOptions={[10]}

                count={data ? data.count : 0}
                page={data ? ( data.count === 0 ? 0 : page-1 ) : 0}
                
                rowsPerPage={rowsPerPage}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true,
                }}
                onChangePage={handleChangePage}
                // onChangeRowsPerPage={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    </Paper>
  );
}